document.addEventListener("DOMContentLoaded", function () {
  const productVariants = JSON.parse(
    document.getElementById("product-variants-json").textContent
  );
  const variantSelects = document.querySelectorAll(".variant-select");
  const addToCartBtn = document.getElementById("add-to-cart-btn");
  const stickyAddToCartBtn = document.getElementById("sticky-add-to-cart");
  const stickyCart = document.getElementById("sticky-cart");
  const productForm = document.getElementById("product-form");

  // Update variant based on selections
  function updateVariant() {
    const selectedOptions = [];
    variantSelects.forEach((select) => {
      selectedOptions.push(select.value);
    });

    const selectedVariant = productVariants.find((variant) => {
      return variant.options.every(
        (option, index) => option === selectedOptions[index]
      );
    });

    if (selectedVariant) {
      updateProductInfo(selectedVariant);
    }
  }

  // Format money function - simplified version
  function formatMoney(cents) {
    // Convert cents to a number if it's a string
    const amount =
      typeof cents === "string" ? parseFloat(cents) / 100 : cents / 100;
    // Format with Indian Rupee symbol and proper formatting
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
      .format(amount)
      .replace(/^(\D+)/, "₹ ");
  }

  // Update product information
  function updateProductInfo(variant) {
    // Update hidden input
    document.getElementById("variant-id").value = variant.id;

    // Update variant title
    const variantTitleElement = document.getElementById("variant-title");
    const stickyVariantTitleElement = document.getElementById(
      "sticky-variant-title"
    );
    if (variantTitleElement) variantTitleElement.textContent = variant.title;
    if (stickyVariantTitleElement)
      stickyVariantTitleElement.textContent = variant.title;

    // Update price
    const priceElement = document.getElementById("variant-price");
    const stickyPriceElement = document.getElementById("sticky-price");
    const formattedPrice = formatMoney(variant.price);

    if (priceElement) {
      priceElement.textContent = formattedPrice;
      priceElement.setAttribute("data-price", variant.price);
    }
    if (stickyPriceElement) {
      stickyPriceElement.textContent = formattedPrice;
    }

    // Update compare at price
    const compareElement = document.getElementById("variant-compare-price");
    const stickyCompareElement = document.getElementById(
      "sticky-compare-price"
    );
    const originalPriceElement = document.getElementById("original-price");
    const discountElement = document.getElementById("discount-percentage");

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      const formattedComparePrice = formatMoney(variant.compare_at_price);

      if (compareElement) compareElement.style.display = "inline";
      if (stickyCompareElement) {
        stickyCompareElement.style.display = "inline";
        stickyCompareElement.textContent = formattedComparePrice;
      }
      if (originalPriceElement)
        originalPriceElement.textContent = formattedComparePrice;

      const discount = variant.compare_at_price - variant.price;
      const discountPercentage = Math.round(
        (discount / variant.compare_at_price) * 100
      );
      if (discountElement)
        discountElement.textContent = `Save ${discountPercentage}%`;
    } else {
      if (compareElement) compareElement.style.display = "none";
      if (stickyCompareElement) stickyCompareElement.style.display = "none";
    }

    // Update availability
    const addToCartText = document.querySelector(".add-to-cart-text");
    const stickyAddToCartText = document.querySelector(
      ".sticky-add-to-cart-text"
    );

    if (variant.available) {
      addToCartBtn.disabled = false;
      stickyAddToCartBtn.disabled = false;
      if (addToCartText) addToCartText.textContent = "Add to Cart";
      if (stickyAddToCartText) stickyAddToCartText.textContent = "Add to Cart";
    } else {
      addToCartBtn.disabled = true;
      stickyAddToCartBtn.disabled = true;
      if (addToCartText) addToCartText.textContent = "Sold Out";
      if (stickyAddToCartText) stickyAddToCartText.textContent = "Sold Out";
    }

    // Update featured image if available
    if (
      variant.featured_image &&
      document.getElementById("sticky-product-image")
    ) {
      document.getElementById("sticky-product-image").src =
        variant.featured_image;
    }
  }


  function addToCart() {
    const variantId = document.getElementById("variant-id").value;
    const quantity = 1;

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Success feedback
        const originalText = addToCartBtn.querySelector(".add-to-cart-text")
          .textContent;
        const stickyOriginalText = stickyAddToCartBtn.querySelector(
          ".sticky-add-to-cart-text"
        ).textContent;

        addToCartBtn.querySelector(".add-to-cart-text").textContent = "Added!";
        stickyAddToCartBtn.querySelector(
          ".sticky-add-to-cart-text"
        ).textContent = "Added!";

        setTimeout(() => {
          addToCartBtn.querySelector(
            ".add-to-cart-text"
          ).textContent = originalText;
          stickyAddToCartBtn.querySelector(
            ".sticky-add-to-cart-text"
          ).textContent = stickyOriginalText;
        }, 2000);

        // Update cart drawer or redirect
        if (typeof window.updateCartDrawer === "function") {
          window.updateCartDrawer();
        }

        // Trigger cart update event
        document.dispatchEvent(new CustomEvent("cart:updated"));
      })
      .catch((error) => {
        console.error("Error adding to cart:", error);
      });
  }

  // Event listeners
  variantSelects.forEach((select) => {
    select.addEventListener("change", updateVariant);
  });

  // Initialize on page load
  if (variantSelects.length > 0) {
    updateVariant();
  }

  if (addToCartBtn) {
    addToCartBtn.addEventListener("click", addToCart);
  }

  if (stickyAddToCartBtn) {
    stickyAddToCartBtn.addEventListener("click", addToCart);
  }

  // Sticky cart visibility
  if (stickyCart) {
    window.addEventListener("scroll", () => {
      const productSection = document.querySelector(
        ".product-detail-mobileView"
      );
      if (productSection) {
        const productRect = productSection.getBoundingClientRect();
        if (productRect.bottom < 0) {
          stickyCart.classList.remove("hidden");
        } else {
          stickyCart.classList.add("hidden");
        }
      }
    });
  }
});
